// The production embed snippet a dealer pastes on their website.
//
// Points at the versioned CDN build of the standalone widget (see the
// eai-website-widget repo: infra/cdn.yaml + scripts/release.sh). The widget's BFF
// resolves `data-widget-uid` → dealer + look/feel + toggles server-side, so the
// page carries only the public widget UID. `data-endpoint` is optional (defaults
// to the prod BFF, widget.engagedai.io) — set GATSBY_WIDGET_ENDPOINT to override
// for a non-prod build.
export const WIDGET_EMBED_URL =
  process.env.GATSBY_WIDGET_EMBED_URL?.trim() || "https://cdn.engagedai.io/v1/embed.js";

const WIDGET_ENDPOINT = process.env.GATSBY_WIDGET_ENDPOINT?.trim() || "";

export function buildEmbedSnippet(widgetUid) {
  if (!widgetUid) {
    return "// Widget UID not available. Please create or select a widget first.";
  }
  const endpointAttr = WIDGET_ENDPOINT ? `\n        data-endpoint="${WIDGET_ENDPOINT}"` : "";
  return `<script src="${WIDGET_EMBED_URL}"${endpointAttr}\n        data-widget-uid="${widgetUid}"></script>`;
}

export default buildEmbedSnippet;
